import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'
import BarChart from '../components/BarChart'
import PieChart from '../components/PieChart'
import GlobalIntershipTable from '../components/GlobalIntershipTable'

import Bubble from '../components/Bubble'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'
import FlickitySlider from '../components/FlickitySlider'
import MoreText from '../components/MoreText'
import VideoButton from '../components/VideoButton'

const TourismTeamMembers = require('../data/TourismTeamMembers')
const TourismCourseTeamMembers = require('../data/TourismCourseTeamMembers')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="Tourism" />

    <div
      className="bg-banner-30 bg-center bg-cover"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-tourism.jpg)`, minHeight: '200px' }}
      id="foster-future-talents"
    >
      <div className="absolute inset-0 py-12">
        <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
          <Bubble className="w-full md:w-1/2"
            title="Foster Future Talents"
            subtitle=""
          >
          </Bubble>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-2/3" data-aos="fade-up">
            <div className="text-left mx-auto text-sm lg:text-base lg:pr-8 font-normal text-justify" data-aos="fade-up" data-aos-delay={600}>
              <p className="mb-4">IFT Tourism College provides the foremost bachelor degree programme of tourism studies in Macao. Integrated with theories and first-hand experience, our bachelor’s degree programmes are widely recognised by the tourism and hospitality industries in Macao and places all over the globe. With numerous global partners and international connections, the College is dedicated to provide the world’s leading, internationalised, and forward-looking education for students.</p>
              <p className="mb-4">Students at the IFT Tourism College do not only learn in the classroom but are also offered experience of facing challenges in preparation for their future careers. Students taking courses under the bachelor degree programmes practise what they learn in the college’s cutting-edge training facilities, which include a training restaurant, a training hotel, a hotel front desk and guest rooms settings, several Chinese and Western kitchens for teaching and cooking demonstrations, and a one of a kind heritage documentation laboratory. They also have opportunities to gain hands-on experience through working on projects, such as activities organisation, participate in charity events, editing food guides and providing consultations for Macao enterprises. </p>
              <p className="mb-4">With a strong international connection, IFT Tourism College encourages students to explore the globe, and return with new experience. Activities like field trips, community services and tours create bonds among students in the tourism and hospitality disciplines, and those who serve in the industries all around the world. </p>
              <p>Unlike many education institutes in Macao, students in the College are required to take a daytime degree of Bachelor of Science with elements of the completion of both a 6-month internship and an undergraduate dissertation, which ensures students’ development on both knowledge and practical experience. Various locations for internship worldwide include Belgium, Mainland China, Dubai, Malaysia, Singapore, Spain, United Kingdom and United States of America. </p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-8 lg:mt-0" data-aos="fade-up" data-aos-delay={800}>
            <Testimonial
              title="Highest Ability"
              color="orange"
            >
              <p>Completing a 6-month internship is mandatory for IFT undergraduates in their third year. Also, before they are allowed to graduate, all students taking daytime programmes leading to the degree of Bachelor of Science must produce a thesis. No other institution of tertiary education in Macao has this combination of requirements.</p>
            </Testimonial>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="our-bachelor-degree-programmes">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Our Bachelor Degree Programmes</h2>
        <div className="flex flex-col flex-wrap">
          <div className="flex flex-row flex-wrap mt-12 w-full px-6 xl:px-0 xl:w-4/5 mx-auto">
            <div className="w-full md:w-1/2 md:pr-4" data-aos="fade-right" data-aos-delay={300}>
              <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Daytime programme:</h4>
              <ul className="list-disc">
                <li>
                  Bachelor of Arts in Culinary Arts Management
                  <p className="pb-2">
                    <span className="text-orange-500">
                      Student Sharing - Bryan Lo
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://www.youtube.com/embed/DmJPHZ39W1w" />
                    </span>
                  </p>
                </li>
                <li>
                  Bachelor of Science in Heritage Management
                  <p className="pb-2">
                    <span className="text-orange-500">
                      Student Sharing - Vicky Chen
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://www.youtube.com/embed/uX40bLbVKWE" />
                    </span>
                  </p>
                </li>
                <li>
                  Bachelor of Science in Hotel Management
                  <p className="pb-2">
                    <span className="text-orange-500">
                      Student Sharing - Victor Zhu
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://www.youtube.com/embed/Tb0L7X1Dbck" />
                    </span>
                  </p>
                </li>
                <li>
                  Bachelor of Science in Tourism Business Management
                  <p className="pb-2">
                    <span className="text-orange-500">
                      Student Sharing - Athena Wong
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://www.youtube.com/embed/UDECRWDoN0Q" />
                    </span>
                  </p>
                </li>
                <li>
                  Bachelor of Science in Tourism Event Management
                  <p className="pb-2">
                    <span className="text-orange-500">
                      Student Sharing - Mandy Ho
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://www.youtube.com/embed/GWgsUV8vcQs" />
                    </span>
                  </p>
                </li>
                <li>
                  Bachelor of Science in Tourism Retail and Marketing Management
                </li>
              </ul>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0" data-aos="fade-left" data-aos-delay={300}>
              <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Evening programme:</h4>
              <ul className="list-disc">
                <li>Bachelor of Science in Hotel Management</li>
                <li>Bachelor of Science in Tourism Event Management</li>
                <li>Bachelor of Science in Tourism Retail and Marketing Management</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container mb-12">
        <div className="flex flex-row flex-wrap mt-12 w-full lg:w-4/5 mx-auto">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-in">
            <Testimonial
              title="The Popular Choice"
              color="blue"
            >
              Our highly acclaimed programmes are now the popular choice for students from Macao and around the world. Application figure soared by 27% for 2017/18 intake when compared with that of the previous year.
            </Testimonial>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-in" data-aos-delay={300}>
            <IllustrationBox
              number={19}
              text="of students enrolled in academic year 2017/18 were from outside of Macao. Most IFT students from outside Macao were from Mainland China; other students came from Hong Kong SAR, Taiwan region and other parts of Asia, Europe and the United States."
              className="text-5xl"
              suffix="%"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="students-enrolled-in-bachelors-degree-programmes">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Students Enrolled in Bachelor’s Degree Programmes</h2>
        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-4/5 md:mt-8 overflow-auto" data-aos="fade-up">
            <BarChart />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={300}>
            <IllustrationBox
              number={29}
              title="nationalities"
              text="were represented among students enrolled in 2017/18."
              className="text-5xl"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12" id="graduates-2017-18">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">2017/18 Graduates</h2>
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-4/5 lg:mt-8 overflow-auto" data-aos="fade-up">
            <PieChart />
          </div>
          <div className="w-full lg:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={300}>
            <IllustrationBox
              number={277}
              title="IFT students"
              text="successfully completed undergraduate thesis in 2017/2018"
              className="text-5xl"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="embrace-all-challenges">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Embrace All Challenges</h2>
        <div className="flex flex-col flex-wrap mt-8">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-5xl font-normal" data-aos="fade-down" data-aos-delay={150}>
              <p>A degree awarded by the IFT Tourism College is popular among employers. Though, our bachelor’s degree programmes do more than just prepare students for employment. A good percentage of IFT graduates go on with their studies at top universities around the world.</p>
            </div>
          </div>
        </div>

        <h4 className="text-2xl md:text-3xl text-blue-500 text-center mt-12 mb-12" data-aos="fade-up" data-aos-delay={300}>
          What was the class of 2018 doing 6 months after graduation?
          <br/>
          <p className="text-sm text-gray-500 mt-6 md:mt-2">
            Source: IFT Career Placement Survey, conducted in December 2018
          </p>
        </h4>

        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={450}>
            <IllustrationBox
              number={70}
              title="Response rate"
              text="of IFT Career Placement Survey 2017/18"
              className="text-5xl"
              suffix="%"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={600}>
            <IllustrationBox
              number={85}
              title="were employed"
              text="or were pursuing further studies"
              className="text-5xl"
              suffix="%"
            />
          </div>
          <div className="w-full md:w-1/5 mt-16 md:mt-8 relative" data-aos="fade-up" data-aos-delay={750}>
            <p className="text-4xl text-blue-600 text-center absolute -mt-10 w-full">Over</p>
            <IllustrationBox
              number={70}
              title="were working"
              text="in Tourism and Hospitality industry"
              className="text-5xl"
              suffix="%"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={900}>
            <IllustrationBox
              number={95}
              title="of those who had full-time employment,"
              text="earning a median monthly pay of MOP15,100"
              className="text-5xl"
              suffix="%"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={1050}>
            <IllustrationBox
              number={82}
              title="recommended IFT"
              text="as a place to study for a bachelor’s degree"
              className="text-5xl"
              suffix="%"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12 md:pb-24" id="academic-staff">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Academic Staff</h2>
        <div className="w-full md:w-1/2 mx-auto my-12 text-center" data-aos="fade-up" data-aos-delay={150}>
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Our Academic Coordinators</h4>
          <div className="mx-auto text-sm md:text-base font-normal">
            <p>IFT Tourism College programme coordinators committed to offer the best educations for students.</p>
          </div>
        </div>

        <FlickitySlider
          resizeListener={
            (resize) => {
              document.querySelectorAll('.more-text').forEach(item => {
                item.addEventListener('click', () => resize())
              })
            }
          }
        >
          {
            TourismTeamMembers.map((member, i) => (
              <div key={i} className={`w-full mb-12 text-center ${(i <= 1 ? 'md:w-1/2' : 'md:w-1/3')}`}>
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500 leading-tight" dangerouslySetInnerHTML={{ __html: member.name['en'] }}></div>
                  <div className="w-full px-4 mb-2 text-sm" dangerouslySetInnerHTML={{ __html: member.title['en'] }}></div>
                  <MoreText className="w-full more-text text-sm font-normal" limitTextLength={ member.textLength || 400 }>
                    { member.description['en'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>

        <div className="w-full md:w-1/2 mx-auto mt-20 mb-12 text-center" data-aos="fade-up">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">Our Regents and Course Coordinators</h4>
          <div className="mx-auto text-sm md:text-base font-normal">
            <p>The regents and course coordinators at IFT design and develop course curriculums and practicums with their expertise. They are in charge of coordinating teaching loads and monitoring the quality of teaching, helping students learn and shape the way they build their skills.</p>
          </div>
        </div>

        <FlickitySlider>
          {
            TourismCourseTeamMembers.map((member, i) => (
              <div key={i} className={`w-full mb-12 text-center md:w-1/4`}>
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500 leading-tight" dangerouslySetInnerHTML={{ __html: member.name['en'] }}></div>
                  <div className="w-full px-4 mb-2 text-sm" dangerouslySetInnerHTML={{ __html: member.title['en'] }}></div>
                  <MoreText className="w-full more-text text-sm font-normal" limitTextLength={ member.textLength || 400 }>
                    { member.description['en'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="student-research">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Student Research</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3" data-aos="fade-right">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
            <div className="inset-0 mt-4">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex" data-aos="fade-left">
            <div className="text-left mx-auto text-sm lg:text-base lg:pl-8 font-normal mt-4 lg:mt-0 text-justify">
              <p className="mb-4">IFT requires all students taking daytime programmes leading to the degree of Bachelor of Science to write a thesis as part of their course of study. </p>
              <p className="mb-4">IFT was the first institution of higher education in Macao with this compulsory graduation requirement. Individual BSc candidates enrolled in a daytime programme at IFT have been mandated to complete a thesis before graduation since academic year 2015/16. The purpose of this requirement is to give undergraduates the chance to think independently and to develop their critical and analytical skills. The conceptualisation and design of projects which culminate in an original research study are undertaken by the students. Throughout the process, students benefit from the direct guidance of a supervisor and ongoing support from the Thesis Writing Centre and the Thesis Research Support Centre. This IFT thesis requirement has drawn international attention since its implementation. Many students have been invited to present their research at international conferences and similar academic events. </p>
              <p>In academic year 2017/18, two students presented and published their research at the International Student Conference in Tourism Research (ISCONTOUR 2018), which took place in May 2018 at IMC University of Applied Sciences Krems, in Austria and a third presented at 7<sup>th</sup> International Conference on Industrial Technology and Management (ICITM 2018) in Oxford UK, Conference participation is an occasion for the transfer of knowledge and networking among graduates, academics, researchers and tourism professionals.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-1/2 mt-8 lg:mt-8 lg:pr-8 mb-8 lg:mb-0" data-aos="zoom-out">
            <Testimonial
              title="Outstanding Achievements"
              color="blue"
            >
              <p>The IFT Tourism Education Student Summit or TEd Summit, is held at the end of each academic year. The event celebrates outstanding researches completed by our students in the form of their undergraduate thesis. This year marked the first time this full-day event was held outside of IFT. The TEd Summit-2018 was hosted by the Regency Art Hotel Macau. The proceedings of each TEd Summit are published online and publicly available on the IFT website.</p>
            </Testimonial>
          </div>
          <div className="w-full lg:w-1/2 lg:mt-16 xl:mt-0" data-aos="flip-down">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="global-internship">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Global Internship</h2>
        <div className="flex flex-col flex-wrap mt-8 mb-12">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-5xl font-normal" data-aos="fade-down" data-aos-delay={150}>
              <p>Students graduated from IFT Tourism College are well equipped with knowledge and first-hand experiences. With IFT strong international connection, and expanding influences in the tourism and hospitality industries, more and more international partners offer opportunities for internships. These valuable opportunities will broaden students’ horizons and prepared them for their career path.</p>
            </div>
          </div>
        </div>

        <div data-aos="fade-up">
          <GlobalIntershipTable
            langKey={props.pageContext.langKey}
            className="mb-12"
          />
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
